import { css } from 'styled-components';

const STATIC_FILES_BASE_URL =
  process.env.STATIC_FILES_BASE_URL ??
  'https://prod-static-files-bucket-qe7n6zmsazm7.s3.eu-west-1.amazonaws.com';

export const fontFaces = css`
  @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

  @font-face {
    font-family: 'NOTHS Suisse Neue';
    src: url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_light.woff2')
        format('woff2'),
      url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_light.woff')
        format('woff');
    font-style: normal;
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: 'NOTHS Suisse Neue';
    src: url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_medium.woff2')
        format('woff2'),
      url('${STATIC_FILES_BASE_URL}/webapps/shared/fonts/noths_suisse_neue_medium.woff')
        format('woff');
    font-style: normal;
    font-weight: 500;
    font-display: swap;
  }
`;
